// /home/labdoo/zitech-nexus/frontend/src/pages/admin/AllRequestDetail.tsx
import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { adminAPI, getStatusBadgeColor, trainingAPI } from '../../services/api';
import './AllRequestDetail.css';

// SVG Icons
const Icons = {
  Close: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Back: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  ),
  User: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Email: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  Company: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Service: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Calendar: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  File: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
    </svg>
  ),
  Download: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 17L12 21L20 17" />
      <path d="M12 3V15M12 15L8 11M12 15L16 11" />
    </svg>
  ),
  View: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Check: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5" strokeLinecap="round">
      <path d="M20 6L9 17L4 12" />
    </svg>
  ),
  StatusDot: () => (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor">
      <circle cx="4" cy="4" r="4" />
    </svg>
  ),
  Spinner: () => (
    <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ard-spinner-svg">
      <path d="M12 2v4M12 22v-4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M22 12h-4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
    </svg>
  ),
  PDF: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
    </svg>
  ),
  Image: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  ),
  Training: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7L12 12L22 7L12 2Z" />
      <path d="M2 17L12 22L22 17" />
      <path d="M2 12L12 17L22 12" />
    </svg>
  ),
};

const AllRequestDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [request, setRequest] = useState<any>(null);
  const [selectedFile, setSelectedFile] = useState<{ url: string; name: string; type: string } | null>(null);
  const [startingTraining, setStartingTraining] = useState(false);
  const [trainingStarted, setTrainingStarted] = useState(false);
  const [showTechModal, setShowTechModal] = useState(false);
  const [selectedTechnologies, setSelectedTechnologies] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(true);
  const [existingEnrollments, setExistingEnrollments] = useState<Set<string>>(new Set());

  const fetchRequest = useCallback(async () => {
    try {
      const response = await adminAPI.getRequest(parseInt(id!));
      setRequest(response.data);
      
      if (response.data.user) {
        await checkExistingEnrollments(response.data.user, response.data.selected_technologies || []);
      }
      
      if (response.data.training_started) {
        setTrainingStarted(true);
      }
    } catch (error) {
      console.error('Error fetching request:', error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  const checkExistingEnrollments = async (userId: number, technologies: string[]) => {
    try {
      const response = await adminAPI.getUserEnrollments(userId);
      const existingTechs = new Set<string>(response.data.map((e: any) => e.technology as string));
      setExistingEnrollments(existingTechs);
      
      const notStartedTechs = technologies.filter(tech => !existingTechs.has(tech));
      setSelectedTechnologies(notStartedTechs);
      setSelectAll(notStartedTechs.length === technologies.length);
    } catch (error) {
      console.error('Error checking enrollments:', error);
      setSelectedTechnologies([...technologies]);
    }
  };

  useEffect(() => {
    fetchRequest();
  }, [fetchRequest]);

  const updateStatus = async (status: string) => {
    try {
      await adminAPI.updateRequestStatus(parseInt(id!), status);
      fetchRequest();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const openTechSelectionModal = () => {
    if (request?.user) {
      checkExistingEnrollments(request.user, request.selected_technologies || []);
    }
    setShowTechModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeTechModal = () => {
    setShowTechModal(false);
    document.body.style.overflow = 'auto';
  };

  const toggleTechnology = (tech: string) => {
    setSelectedTechnologies(prev => {
      const newSelection = prev.includes(tech) 
        ? prev.filter(t => t !== tech)
        : [...prev, tech];
      return newSelection;
    });
  };

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedTechnologies([]);
      setSelectAll(false);
    } else {
      const notStartedTechs = request?.selected_technologies.filter(
        (tech: string) => !existingEnrollments.has(tech)
      ) || [];
      setSelectedTechnologies(notStartedTechs);
      setSelectAll(true);
    }
  };

  const handleStartTraining = async () => {
    if (selectedTechnologies.length === 0) {
      alert('Please select at least one technology to start training.');
      return;
    }

    if (!window.confirm(
      `Start training for ${request.user_name}?\n\n` +
      `Technologies: ${selectedTechnologies.join(', ')}\n\n` +
      `This will create training enrollments for the user.`
    )) {
      return;
    }

    setStartingTraining(true);
    closeTechModal();

    try {
      await trainingAPI.startTraining(parseInt(id!), selectedTechnologies);
      setTrainingStarted(true);
      alert(`Training started successfully!\n\nEnrollments created for: ${selectedTechnologies.join(', ')}`);
      fetchRequest();
    } catch (error: any) {
      console.error('Error starting training:', error);
      const errorMsg = error.response?.data?.error || 'Failed to start training. Make sure the request is approved.';
      alert(errorMsg);
    } finally {
      setStartingTraining(false);
    }
  };

  const getServiceDisplayName = (): string => {
    if (!request) return 'Unknown Service';
    
    if (request.service_name_display) {
      return request.service_name_display;
    }
    if (request.service_name) {
      return request.service_name.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase());
    }
    if (request.service && typeof request.service === 'object') {
      return request.service.name?.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase()) || 'Unknown Service';
    }
    if (request.service && typeof request.service === 'string') {
      return request.service.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase());
    }
    return 'Unknown Service';
  };

  const isTrainingRequest = (): boolean => {
    const serviceName = getServiceDisplayName();
    return serviceName === 'Training Programs' || request?.service_name === 'training_programs';
  };

  const canStartTraining = (): boolean => {
    const allTechnologiesStarted = request?.selected_technologies?.length > 0 && 
      request.selected_technologies.every((tech: string) => existingEnrollments.has(tech));
    
    return isTrainingRequest() && 
           request?.status === 'approved' && 
           request?.selected_technologies && 
           request.selected_technologies.length > 0 &&
           !trainingStarted &&
           !allTechnologiesStarted;
  };

  const getStatusColor = (status: string) => {
    switch(status) {
      case 'pending': return '#f59e0b';
      case 'in_review': return '#0ea5e9';
      case 'approved': return '#10b981';
      case 'in_progress': return '#8b5cf6';
      case 'completed': return '#10b981';
      case 'cancelled': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getStatusBackground = (status: string) => {
    switch(status) {
      case 'pending': return '#fef3c7';
      case 'in_review': return '#dbeafe';
      case 'approved': return '#d1fae5';
      case 'in_progress': return '#ede9fe';
      case 'completed': return '#d1fae5';
      case 'cancelled': return '#fee2e2';
      default: return '#f3f4f6';
    }
  };

  const getStatusLabel = (status: string) => {
    switch(status) {
      case 'pending': return 'Pending';
      case 'in_review': return 'In Review';
      case 'approved': return 'Approved';
      case 'in_progress': return 'In Progress';
      case 'completed': return 'Completed';
      case 'cancelled': return 'Cancelled';
      default: return status;
    }
  };

  const formatFileSize = (bytes: number) => {
    if (!bytes) return '0 B';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const isImageFile = (fileName: string) => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'].includes(extension || '');
  };

  const isPdfFile = (fileName: string) => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    return extension === 'pdf';
  };

  const getFileUrl = (filePath: string) => {
    if (!filePath) return '';
    if (filePath.startsWith('http')) return filePath;
    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    return `${baseUrl}${filePath}`;
  };

  const openFileViewer = (fileUrl: string, fileName: string) => {
    const isImage = isImageFile(fileName);
    const isPdf = isPdfFile(fileName);
    setSelectedFile({
      url: fileUrl,
      name: fileName,
      type: isPdf ? 'pdf' : isImage ? 'image' : 'other'
    });
    document.body.style.overflow = 'hidden';
  };

  const closeFileViewer = () => {
    setSelectedFile(null);
    document.body.style.overflow = 'auto';
  };

  const allTechnologiesStarted = request?.selected_technologies?.length > 0 && 
    request.selected_technologies.every((tech: string) => existingEnrollments.has(tech));

  if (loading) {
    return (
      <div className="ard-loading-container">
        <div className="ard-spinner">
          <Icons.Spinner />
        </div>
        <p className="ard-loading-text">Loading request details...</p>
      </div>
    );
  }

  if (!request) {
    return (
      <div className="ard-error-container">
        <div className="ard-error-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>
        <h2 className="ard-error-title">Request Not Found</h2>
        <p className="ard-error-text">The request you're looking for doesn't exist or has been removed.</p>
        <button className="ard-error-btn" onClick={() => navigate('/dashboard/admin/requests')}>
          <Icons.Back />
          Back to Requests
        </button>
      </div>
    );
  }

  return (
    <div className="ard-container">
      {/* File Viewer Modal */}
      {selectedFile && (
        <div className="ard-file-modal-overlay" onClick={closeFileViewer}>
          <div className="ard-file-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ard-file-modal-header">
              <h3 className="ard-file-modal-title">
                {selectedFile.type === 'pdf' ? <Icons.PDF /> : selectedFile.type === 'image' ? <Icons.Image /> : <Icons.File />}
                {selectedFile.name}
              </h3>
              <button className="ard-file-modal-close" onClick={closeFileViewer}>
                <Icons.Close />
              </button>
            </div>
            <div className="ard-file-modal-body">
              {selectedFile.type === 'pdf' ? (
                <iframe
                  src={selectedFile.url}
                  className="ard-file-pdf-viewer"
                  title={selectedFile.name}
                  frameBorder="0"
                />
              ) : selectedFile.type === 'image' ? (
                <div className="ard-file-image-container">
                  <img src={selectedFile.url} alt={selectedFile.name} className="ard-file-image" />
                </div>
              ) : (
                <div className="ard-file-placeholder">
                  <Icons.File />
                  <p>This file type cannot be previewed.</p>
                </div>
              )}
            </div>
            <div className="ard-file-modal-footer">
              <a href={selectedFile.url} download className="ard-file-download-btn">
                <Icons.Download />
                Download
              </a>
              <button className="ard-file-close-btn" onClick={closeFileViewer}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Technology Selection Modal */}
      {showTechModal && (
        <div className="ard-modal-overlay" onClick={closeTechModal}>
          <div className="ard-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ard-modal-header">
              <h3 className="ard-modal-title">Select Technologies to Start Training</h3>
              <button className="ard-modal-close" onClick={closeTechModal}>
                <Icons.Close />
              </button>
            </div>
            <div className="ard-modal-body">
              <p className="ard-modal-user">
                Starting training for: <strong>{request.user_name}</strong>
              </p>
              
              {existingEnrollments.size > 0 && (
                <div className="ard-already-started">
                  <Icons.Check />
                  <span>Already in training: <strong>{Array.from(existingEnrollments).join(', ')}</strong></span>
                </div>
              )}
              
              <div className="ard-select-all">
                <label className="ard-checkbox-label">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={toggleSelectAll}
                    disabled={request.selected_technologies.filter((t: string) => !existingEnrollments.has(t)).length === 0}
                    className="ard-checkbox"
                  />
                  <span>Select All Technologies</span>
                </label>
              </div>
              
              <div className="ard-tech-list">
                {request.selected_technologies.map((tech: string) => {
                  const isAlreadyStarted = existingEnrollments.has(tech);
                  const isSelected = selectedTechnologies.includes(tech);
                  
                  return (
                    <label 
                      key={tech} 
                      className={`ard-tech-item ${isAlreadyStarted ? 'ard-tech-started' : ''}`}
                    >
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => toggleTechnology(tech)}
                        disabled={isAlreadyStarted}
                        className="ard-checkbox"
                      />
                      <span className="ard-tech-name">{tech}</span>
                      {isAlreadyStarted && (
                        <span className="ard-tech-badge">Already in training</span>
                      )}
                    </label>
                  );
                })}
              </div>
              
              {selectedTechnologies.length === 0 && (
                <p className="ard-tech-warning">
                  {allTechnologiesStarted
                    ? "All technologies are already in training for this user"
                    : "Please select at least one technology to start training"}
                </p>
              )}
            </div>
            <div className="ard-modal-footer">
              <button className="ard-modal-cancel" onClick={closeTechModal}>
                Cancel
              </button>
              <button 
                className="ard-modal-start"
                onClick={handleStartTraining}
                disabled={selectedTechnologies.length === 0 || startingTraining}
              >
                {startingTraining ? 'Starting...' : `Start Training (${selectedTechnologies.length})`}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="ard-header">
        <div className="ard-header-left">
          <button className="ard-back-btn" onClick={() => navigate('/dashboard/admin/requests')}>
            <Icons.Back />
            Back to Requests
          </button>
          <h1 className="ard-title">Service Request #{request.id}</h1>
          <div className="ard-meta">
            <span className="ard-meta-item">
              <Icons.Service />
              {getServiceDisplayName()}
            </span>
            <span className="ard-meta-divider">|</span>
            <span className="ard-meta-item">
              <Icons.User />
              {request.user_name}
            </span>
            <span className="ard-meta-divider">|</span>
            <span className="ard-meta-item">
              <Icons.Calendar />
              {new Date(request.created_at).toLocaleDateString('en-US', { 
                month: 'long', 
                day: 'numeric', 
                year: 'numeric' 
              })}
            </span>
          </div>
        </div>
        <div className="ard-header-status">
          <span 
            className="ard-status-badge-large"
            style={{
              background: getStatusBackground(request.status),
              color: getStatusColor(request.status)
            }}
          >
            <Icons.StatusDot />
            {getStatusLabel(request.status)}
          </span>
        </div>
      </div>

      {/* Detail Grid */}
      <div className="ard-detail-grid">
        {/* Left Column */}
        <div className="ard-detail-left">
          {/* Request Information */}
          <div className="ard-card">
            <h3 className="ard-card-title">Request Information</h3>
            <div className="ard-info-row">
              <span className="ard-info-label">Service</span>
              <span className="ard-info-value">{getServiceDisplayName()}</span>
            </div>
            <div className="ard-info-row">
              <span className="ard-info-label">Status</span>
              <span className="ard-info-value">
                <select 
                  className="ard-status-select"
                  style={{
                    background: getStatusBackground(request.status),
                    color: getStatusColor(request.status),
                    borderColor: getStatusColor(request.status)
                  }}
                  value={request.status}
                  onChange={(e) => updateStatus(e.target.value)}
                >
                  <option value="pending">Pending</option>
                  <option value="in_review">In Review</option>
                  <option value="approved">Approved</option>
                  <option value="in_progress">In Progress</option>
                  <option value="completed">Completed</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </span>
            </div>
            <div className="ard-info-row">
              <span className="ard-info-label">Submitted</span>
              <span className="ard-info-value">
                <Icons.Calendar />
                {new Date(request.created_at).toLocaleString()}
              </span>
            </div>
            <div className="ard-info-row">
              <span className="ard-info-label">Updated</span>
              <span className="ard-info-value">
                <Icons.Calendar />
                {new Date(request.updated_at).toLocaleString()}
              </span>
            </div>
          </div>

          {/* User Information */}
          <div className="ard-card">
            <h3 className="ard-card-title">User Information</h3>
            <div className="ard-info-row">
              <span className="ard-info-label">
                <Icons.User />
                Name
              </span>
              <span className="ard-info-value">{request.user_name}</span>
            </div>
            <div className="ard-info-row">
              <span className="ard-info-label">
                <Icons.Email />
                Email
              </span>
              <span className="ard-info-value">{request.user_email}</span>
            </div>
            <div className="ard-info-row">
              <span className="ard-info-label">
                <Icons.Company />
                Company
              </span>
              <span className="ard-info-value">{request.company_name || 'Not specified'}</span>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="ard-detail-right">
          {/* Project Details */}
          <div className="ard-card">
            <h3 className="ard-card-title">Project Details</h3>
            <div className="ard-project-details">
              <p>{request.project_details}</p>
            </div>
          </div>

          {/* Technologies */}
          {request.selected_technologies && request.selected_technologies.length > 0 && (
            <div className="ard-card">
              <h3 className="ard-card-title">Technologies</h3>
              <div className="ard-tech-tags">
                {request.selected_technologies.map((tech: string, index: number) => (
                  <span 
                    key={index} 
                    className={`ard-tech-tag ${existingEnrollments.has(tech) ? 'ard-tech-tag-started' : ''}`}
                  >
                    {tech}
                    {existingEnrollments.has(tech) && <Icons.Check />}
                  </span>
                ))}
              </div>
              {allTechnologiesStarted && (
                <div className="ard-all-started">
                  <Icons.Check />
                  All technologies have already been started for this user
                </div>
              )}
            </div>
          )}

          {/* Attachments */}
          {request.attachments && request.attachments.length > 0 && (
            <div className="ard-card">
              <h3 className="ard-card-title">
                Attachments ({request.attachments.length})
              </h3>
              <div className="ard-attachments">
                {request.attachments.map((attachment: any, index: number) => {
                  const fileUrl = getFileUrl(attachment.file);
                  const isImage = isImageFile(attachment.file_name);
                  const isPdf = isPdfFile(attachment.file_name);
                  const displayFileName = attachment.file_name.length > 50 
                    ? attachment.file_name.substring(0, 47) + '...' 
                    : attachment.file_name;
                  
                  return (
                    <div key={index} className="ard-attachment-item">
                      {isImage ? (
                        <div className="ard-image-preview">
                          <img 
                            src={fileUrl} 
                            alt={attachment.file_name}
                            className="ard-image-thumbnail"
                            onClick={() => openFileViewer(fileUrl, attachment.file_name)}
                          />
                          <div className="ard-image-overlay">
                            <button 
                              className="ard-view-btn"
                              onClick={() => openFileViewer(fileUrl, attachment.file_name)}
                            >
                              <Icons.View />
                              View Image
                            </button>
                          </div>
                        </div>
                      ) : isPdf ? (
                        <div className="ard-file-item">
                          <Icons.PDF />
                          <div className="ard-file-info">
                            <p className="ard-file-name" title={attachment.file_name}>
                              {displayFileName}
                            </p>
                            <p className="ard-file-size">{formatFileSize(attachment.file_size)}</p>
                          </div>
                          <div className="ard-file-actions">
                            <button 
                              className="ard-view-btn"
                              onClick={() => openFileViewer(fileUrl, attachment.file_name)}
                            >
                              <Icons.View />
                              View PDF
                            </button>
                            <a href={fileUrl} download className="ard-download-btn">
                              <Icons.Download />
                            </a>
                          </div>
                        </div>
                      ) : (
                        <div className="ard-file-item">
                          <Icons.File />
                          <div className="ard-file-info">
                            <p className="ard-file-name" title={attachment.file_name}>
                              {displayFileName}
                            </p>
                            <p className="ard-file-size">{formatFileSize(attachment.file_size)}</p>
                          </div>
                          <div className="ard-file-actions">
                            <a href={fileUrl} download className="ard-download-btn">
                              <Icons.Download />
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {/* Start Training Section */}
          {canStartTraining() && (
            <div className="ard-card ard-card-training">
              <h3 className="ard-card-title">
                <Icons.Training />
                Start Training
              </h3>
              <button 
                className="ard-start-training-btn"
                onClick={openTechSelectionModal}
                disabled={startingTraining}
              >
                {startingTraining ? 'Starting Training...' : '🎓 Start Training for User'}
              </button>
              <p className="ard-start-training-hint">
                Click to select which technologies to start training for this user.
                <br />
                <span className="ard-available-techs">
                  Available: {request.selected_technologies?.filter((t: string) => !existingEnrollments.has(t)).join(', ') || 'None'}
                </span>
                {request.selected_technologies?.filter((t: string) => existingEnrollments.has(t)).length > 0 && (
                  <span className="ard-already-started-hint">
                    ✅ Already started: {request.selected_technologies?.filter((t: string) => existingEnrollments.has(t)).join(', ')}
                  </span>
                )}
              </p>
            </div>
          )}

          {trainingStarted && allTechnologiesStarted && (
            <div className="ard-card ard-card-completed">
              <h3 className="ard-card-title">
                <Icons.Check />
                Training Completed
              </h3>
              <div className="ard-completed-message">
                <Icons.Check />
                All training has been started for this user. They can now access their learning materials in the "My Learning" section.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllRequestDetail;